import React from "react";
import { Container } from "reactstrap";

//Import Breadcrumb
import ProductCarousel from '../../components/ProductCarousel';

const ProductRange = () => {
    document.title = "ProductRange";
    return (
        <React.Fragment>
            <div>
                <ProductCarousel /> 
            </div>
        </React.Fragment>
    );
};

export default ProductRange;
